import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
// import axios from 'axios'


// or with options
const loadimage = require('./assets/loading-spin.svg')
const errorimage = require('./assets/logo.png')




createApp(App).use(router).mount('#app')